/* HIKE */
export const HIKE_LIST = "HIKE_LIST";
export const HIKE_LIST_SUCCESS = "HIKE_LIST_SUCCESS";
export const HIKE_LIST_FAILED = "HIKE_LIST_FAILED";

